if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"umi": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"layouts__Blank__index":1,"p__Reports__BranchMonthlySales__Maximized":1,"p__Reports__BranchMonthlySales__DailyBreakdown":1,"p__Reports__BranchDailySalesCompare__Maximized":1,"p__Reports__StockMovement__Maximized":1,"vendors-node_modules_ant-design_icons_es_icons_ExpandOutlined_js-node_modules_antv_s2-react-c-08c204":1,"src_components_PivotHeaderFilters_index_less-src_pages_Reports_BranchDailySales_index_less-sr-e9883d":1,"p__Reports__SalesBySku__SalesBySkuPivotExpand":1,"p__Reports__BranchDailySalesCompare__DayBreakdown":1,"p__Dashboard__WeeklyCompanyReport__index":1,"layouts__Basic__index":1,"src_components_DenseOverview_index_tsx":1,"p__Home__BranchInfo__index":1,"p__Home__FiscalCalendar__index":1,"p__Dashboard__BestSellerRanking__index":1,"p__Dashboard__Product360__index":1,"p__Dashboard__ProductStockHealth__index":1,"p__Dashboard__SkuWeeklyTracker__index":1,"p__Dashboard__SkuSalesMovement__index":1,"p__Dashboard__Membership__index":1,"src_pages_Dashboard_DailySales_BranchHistoryDrawer_tsx-src_pages_Dashboard_DailySales_DailySa-5e38b6":1,"p__Dashboard__DailySales__index":1,"p__Dashboard__SalesSummary__index":1,"p__Dashboard__SingleBranchPerformance__index":1,"p__Dashboard__BranchPerformance__index":1,"p__Dashboard__BranchFinancialPerformance__index":1,"p__Dashboard__PromotionPerformance__index":1,"p__Dashboard__Inventory__index":1,"node_modules_ant-design_icons_es_icons_BookOutlined_js-src_components_ExportHistory_ExportHis-511164":1,"p__Reports__BranchDailySales__index":1,"p__Reports__BranchDailySales__BranchDailyPivotExpand":1,"p__Reports__HourlySales__index":1,"p__Reports__HourlySales__HourlySalesPivotExpand":1,"p__Reports__BranchDailySalesCompare__index":1,"p__Reports__BranchMonthlySales__index":1,"p__Reports__YearlySalesComparison__index":1,"p__Reports__FiscalWeeklySales__index":1,"p__Reports__ExportHistory__index":1,"p__Reports__SalesBySku__index":1,"p__Reports__SalesByPromotion__index":1,"src_components_PortalProTable_buildDynamicReportColumns_ts-src_components_PortalProTable_inde-05d179":1,"p__Reports__CouponUsage__index":1,"p__Reports__CouponUsage__CouponUsagePivotExpand":1,"p__Reports__VoucherUsage__index":1,"p__Reports__VoucherUsage__VoucherUsagePivotExpand":1,"p__Reports__PoDetails__PoDetailsPivotExpand":1,"p__Reports__GrnDetails__GrnDetailsPivotExpand":1,"p__Reports__DoDetails__DoDetailsPivotExpand":1,"p__Reports__StockInventory__index":1,"p__Reports__StockAging__index":1,"p__Reports__StockAging__StockAgingPivotExpand":1,"p__Reports__StockMovement__index":1,"p__Reports__BranchStockBalance__BranchStockBalancePivotExpand":1,"p__Tools__PoChecker__index":1,"p__Tools__DoChecker__index":1,"p__Tools__GrChecker__index":1,"p__Tools__SkuChecker__index":1,"p__Tools__QohChecker__index":1,"p__Tools__PriceChecker__index":1,"p__Tools__PromotionChecker__index":1,"p__Admin__Settings__Email__index":1,"p__Admin__Branches__index":1,"p__Admin__SyncTools__index":1,"p__Admin__Users__index":1,"src_components_PortalErrorPrompt_index_tsx-node_modules_antd_es__util_PurePanel_js-node_modul-5d7ba0":1,"src_components_PivotHeaderFilters_index_less-_f5420":1,"src_components_PivotHeaderFilters_index_less-_f5421":1,"src_components_PivotHeaderFilters_index_less-_f5422":1,"src_components_PivotHeaderFilters_index_less-_f5423":1,"src_components_PivotHeaderFilters_index_less-_f5424":1,"src_components_PivotHeaderFilters_index_less-_f5425":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = function(options) {
	return { dispose: function() {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: function() {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = function(chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function(chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise(function(resolve, reject) {
			var tag = createStylesheet(chunkId, fullhref, oldTag, function() {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}